<section>
  <app-form-header [menuDefinition]="menuDefinition" (onSave)="onSubmit()" (onCancel)="cancel()"></app-form-header>

  @if (form) {
    <form class="astral-content-width astral-stack-l" [formGroup]="form" (ngSubmit)="onSubmit()">
      <section class="astral-section-surface">
        <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1">
          <astral-input [control]="form.controls['name']"></astral-input>
        </astral-layout-group>
      </section>
      @for (componentGroup of $any(componentTypes.controls); track componentGroup; let typeIndex = $index) {
        <section
          class="astral-section-surface astral-stack-l"
          [formGroup]="$any(componentGroup)"
          >
          <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1">
            <astral-input [control]="$any(componentGroup).controls['name']"></astral-input>
            <astral-input type="number" [control]="$any(componentGroup).controls['lifeSpanYears']"></astral-input>
          </astral-layout-group>
          <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
            <astral-toggle [control]="$any(componentGroup).controls['standardInBathroom']" [helpText]="'COMPONENT.HELP_TEXT.STANDARD_IN_ROOM'"></astral-toggle>
            <astral-toggle [control]="$any(componentGroup).controls['standardInBedroom']" [helpText]="'COMPONENT.HELP_TEXT.STANDARD_IN_ROOM'"></astral-toggle>
            <astral-toggle [control]="$any(componentGroup).controls['standardInDressingRoom']" [helpText]="'COMPONENT.HELP_TEXT.STANDARD_IN_ROOM'"></astral-toggle>
            <astral-toggle [control]="$any(componentGroup).controls['standardInHallway']" [helpText]="'COMPONENT.HELP_TEXT.STANDARD_IN_ROOM'"></astral-toggle>
            <astral-toggle [control]="$any(componentGroup).controls['standardInKitchen']" [helpText]="'COMPONENT.HELP_TEXT.STANDARD_IN_ROOM'"></astral-toggle>
            <astral-toggle [control]="$any(componentGroup).controls['standardInLivingRoom']" [helpText]="'COMPONENT.HELP_TEXT.STANDARD_IN_ROOM'"></astral-toggle>
            <astral-toggle [control]="$any(componentGroup).controls['standardInToilet']" [helpText]="'COMPONENT.HELP_TEXT.STANDARD_IN_ROOM'"></astral-toggle>
            <astral-toggle [control]="$any(componentGroup).controls['standardInBalcony']" [helpText]="'COMPONENT.HELP_TEXT.STANDARD_IN_ROOM'"></astral-toggle>
            <astral-toggle [control]="$any(componentGroup).controls['standardInOther']" [helpText]="'COMPONENT.HELP_TEXT.STANDARD_IN_ROOM'"></astral-toggle>
          </astral-layout-group>
          @for (propertyGroup of $any(componentGroup).controls['customProperties'].controls; track propertyGroup; let propertyIndex = $index) {
            <section
              class="astral-section-surface astral-section-surface--compact astral-stack-m"
              [formGroup]="$any(propertyGroup)"
              >
              <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1" [alignItems]="'center'">
                <astral-select [control]="$any(propertyGroup).controls['property']" [itemsSource]="propertySelection"></astral-select>
                <astral-toggle [control]="$any(propertyGroup).controls['mandatory']"></astral-toggle>
                <div class="astral-form-adjacent-action">
                  <astral-button
                    variant="secondary"
                    size="extra-small"
                    type="button"
                    icon="trash"
                    labelKey="COMPONENT.CATEGORY_FORM.DELETE_PROPERTY"
                    (click)="deleteProperty(typeIndex, propertyIndex)"
                  ></astral-button>
                </div>
              </astral-layout-group>
            </section>
          }
          <div class="astral-form-actions">
            <astral-button
              variant="primary"
              size="extra-small"
              type="button"
              icon="plus"
              labelKey="COMPONENT.CATEGORY_FORM.ADD_PROPERTY"
              (click)="addProperty(typeIndex)"
            ></astral-button>
            <astral-button
              variant="secondary"
              size="extra-small"
              type="button"
              icon="trash"
              labelKey="COMPONENT.CATEGORY_FORM.DELETE_TYPE"
              (click)="deleteType(typeIndex)"
            ></astral-button>
          </div>
        </section>
      }
      <astral-button variant="primary" size="small" type="button" icon="plus" labelKey="COMPONENT.CATEGORY_FORM.ADD_TYPE" (click)="addType()"></astral-button>
    </form>
  }
</section>
